import React from "react";
import { strings } from "../../../../../../../../intl/fa";
import Modal from "components/commons/modal/Modal";
import styles from "./CreditNotActiveModal.module.scss";

type Props = {
  onClose: () => void;
};
export const CreditNotActiveModal: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <Modal
      title={strings.credit_not_active_modal.activating_campaign}
      primaryButton={{
        onClick: props.onClose,
        label: strings.common.button.understood,
      }}
      onClose={(e) => {
        e?.stopPropagation();
        props.onClose();
      }}
      mobileBottomSheet
    >
      <img src="/images/awaitingCreditActivation.svg" alt="" />
      <p className={styles.ModalText}>
        {strings.credit_not_active_modal.warning_text}
      </p>
    </Modal>
  );
};
